import ActionType from "../../action/ActionType";

const agentAction = (state = {}, {type, agentDetail}) => {
    if (type === ActionType.AGENT) {
        return agentDetail;
    }
    return state;
};

export default agentAction;